<template>
  <div v-show="babyDetailShow" class="babyDetail">
    <div v-show="datailpage" class="detail">
      <!-- <span class="gobackBtn2" @click="tobabyHander">
        <img src="../../../assets/images/icon/back1.png" class="backimg" alt />
      </span> -->
      <!-- 小程序环境隐藏返回导航 -->
      <goBack v-if="!checkFromMiniprogram" className="detail_top" @goBack="tobabyHander"></goBack>
      <!-- 文章标题 -->
      <div class="detail_top">
        <h3 class="detail_title">
          <!-- 小程序环境隐藏返回按钮 -->
          <span v-if="!checkFromMiniprogram" class="gobackBtn" @click.stop="tobabyHander">
            <van-icon name="arrow-left" />
          </span>
          {{ title }}
        </h3>
        <!-- 文章分类 -->
        <div class="detail_tag_read">
          <!-- <span
              v-if="articleTList != null && articleTList.length != 0"
              class="tag"
          >{{ articleTList[0].name }}</span
          > -->
          <span class="read">已有{{ pv }}星妈看过</span>
          <!-- <span class="collect addColl" v-show="!collectShow" @click="collect(true)"></span> -->
          <!-- <span class="collect cancelColl" v-show="collectShow" @click="collect(false)"></span> -->
        </div>
      </div>
      <!-- 文章详情 -->
      <div class="detail_content" v-html="articalDetial"></div>
      <!-- 小程序环境隐藏好物推荐 -->
      <!-- 好物推荐推荐 -->
      <div
        v-if="!checkFromMiniprogram && isRecommendSwitch == 0 && itemList.length > 0"
        class="recommend"
      >
        <div class="recommend-header">
          <i></i>
          <h3>好物推荐</h3>
        </div>
        <van-list
          v-model="isListLoading"
          :finished="finished"
          :immediate-check="false"
          class="product-list-wrap"
        >
          <div class="product-list-wrap">
            <ul class="product-list">
              <li
                v-for="(item, index) in itemList"
                v-if="item.payType == 8 || item.payType == 6"
                :key="index"
                :data="JSON.stringify(item)"
                :index="index"
                class="product-item"
              >
                <div class="tagWrap">
                  <openWxTag
                    :id="'xmyxItem' + index"
                    :path="
                      '/subPackages/shopMainProcess/product/index?productId=' +
                      item.itemId +
                      '&skuId=' +
                      item.skuId +
                      '&actionLinkCode=10013'
                    "
                    btnStyle="width:100%;height:245px"
                    @sensorsFn="toArticle(item, index)"
                  >
                  </openWxTag>
                </div>
                <img :src="item.picUrl" alt height="134px" width="134px" />
                <div class="product-title">{{ item.itemTitle }}</div>
                <div class="product-price">
                  {{ item.finalPrice }}
                </div>
              </li>
            </ul>
          </div>
        </van-list>
      </div>
      <!-- 小程序环境隐藏分享关注引导 -->
      <!-- 分享关注引导 -->
      <share-guide v-if="!checkFromMiniprogram" @shareGio="gioShare"></share-guide>
      <!-- 小程序环境隐藏评论输入框 -->
      <!-- 评论框 -->
      <comment-Field
        v-if="!checkFromMiniprogram"
        ref="focus"
        :articalId="articalId"
        :carrierId="carrierId"
        :collectNum="collectNum"
        :commentTotal="commentTotal"
        :currentTop="currentTop"
        :isGoLogin="isGoLogin"
        :title="title"
        :tlabelName="tlabelName"
        :commodityObj="commodityObj"
        :referrerItemId="referrerItemId"
        @collectNumAdd="collectNumAdd"
      ></comment-Field>
      <!-- 小程序环境隐藏全部评论 -->
      <!-- 全部评论 -->
      <all-Comment
        v-if="!checkFromMiniprogram"
        ref="allComment"
        :articalId="articalId"
        :carrierId="carrierId"
        :isGoLogin="isGoLogin"
        :title="title"
        :tlabelName="tlabelName"
        @comTotal="getCommentTotal($event)"
        @focusOn="getFocusOn"
        @type="getType"
      ></all-Comment>
    </div>
    <!-- 智能文章推荐 -->
<!--    <div-->
<!--      v-if="isRecommendSwitch == 0 && recommendList && recommendList.length > 0"-->
<!--      :class="itemList.length > 0 ? '' : 'mb80'"-->
<!--      class="recommend"-->
<!--    >-->
<!--      <div class="recommend-header">-->
<!--        <i></i>-->
<!--        <h3>你可能感兴趣</h3>-->
<!--      </div>-->
<!--      <div class="recommend-cont">-->
<!--        <mySwiper-->
<!--          :loop="false"-->
<!--          :readingTime="readingTime"-->
<!--          :recommendList="recommendList"-->
<!--          :referrerItemId="referrerItemId"-->
<!--          :slidesNum="1.1"-->
<!--          :spaceBetweenNum="8"-->
<!--          :swipeid="'detail_recommend_swiper'"-->
<!--          :userId="getCookie('xmh_unionid')"-->
<!--        >-->
<!--          <div-->
<!--            v-for="(item, index) in recommendList"-->
<!--            :key="index"-->
<!--            slot="swiper-con"-->
<!--            class="swiper-slide recommend-cont-list"-->
<!--            @click.stop="toBabyDetail(item, index)"-->
<!--          >-->
<!--            <div :data="JSON.stringify(item, index)">-->
<!--              <h4>{{ item.title }}</h4>-->
<!--              <div>-->
<!--                <span>{{ fomatterNum(item.pv) }}妈妈看过</span>-->
<!--                <span>{{ fomatterNum(item.collectNum) }}收藏</span>-->
<!--              </div>-->
<!--            </div>-->
<!--            <img :src="item.coverUrl" alt="" />-->
<!--          </div>-->
<!--        </mySwiper>-->
<!--      </div>-->
<!--    </div>-->
    <div class="content" v-html="content"></div>
    <!-- <loginTip
      :tipstr="''"
      :okText="'去注册'"
      :closeText="'狠心放弃'"
      :messageText="'注册/登录后阅读文章可获取成长值，加速升级哦'"
      :show="loginPopflag"
      @confirmWay="confirmWay"
      @cancleWay="cancleWay"
    ></loginTip> -->
  </div>
</template>

<style lang="less" scoped>
.mb80 {
  margin-bottom: 80px;
}

.content {
  display: none;
}

.recommend {
  font-family: PingFang-SC-Medium, PingFang-SC;
  padding-bottom: 20px;
  overflow: hidden;
  // height: 300px;
  // margin-bottom: 100px;
  background: #f8f8f8;

  .recommend-header {
    padding: 18px 12px 8px;
    display: flex;
    align-items: center;

    i {
      display: inline-block;
      width: 6px;
      height: 18px;
      background: #fad233;
      border-radius: 6px;
      margin-right: 4px;
      margin-top: -1px;
    }

    h3 {
      display: inline-block;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
  }

  .recommend-cont {
    overflow: hidden;
    margin: 0 12px;

    .recommend-cont-list {
      // width: 299px;
      background: #ffffff;
      padding: 14px 10px;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;

      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h4 {
          width: 202px;
          font-size: 14px;
          color: #333333;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        > div {
          span {
            font-size: 12px;
            color: #999999;
          }

          span:first-child {
            margin-right: 8px;
          }
        }
      }

      > img {
        border-radius: 6px;
        width: 86px;
      }
    }
  }
}

.babyIndex {
  min-height: 100%;
  background: rgba(248, 248, 248, 1);
}

/deep/ .van-list__finished-text {
  margin-bottom: 80px;
  margin-top: 12px;
  color: #ccc !important;
  background: #f8f8f8;
}

.babyDetail {
  min-height: 100%;
  padding-top: 20px;
  padding-bottom: 60px;
  background: @expertFontColor255;
  // position: fixed;
  // top:0;
  // left:0;
  // right:0;
  // bottom: 0;
  // overflow: auto; // 为了list加载注释掉
  -webkit-overflow-scrolling: touch;

  img {
    width: 100%;
  }

  .detail {
    min-height: 100%;
    // overflow: hidden;
  }

  // .gobackBtn2 {
  //   z-index: 100;
  //   display: none;
  //   position: fixed;
  //   width: 26px;
  //   height: 25px;
  //   top: 10px;
  //   left: 12px;
  //   // background-image: url('./../../assets/images/home/back.png');
  //   // background-size: 100% 100%;
  //   img {
  //     width: 26px;
  //     height: 26px;
  //   }
  // }
  // 文章标题
  .detail_top {
    padding-left: 12px;
    padding-right: 12px;

    .detail_title {
      width: 341px;
      font-size: 18px;
      font-family: PingFang-SC;
      font-weight: bold;
      color: @expertFontColor51;
      line-height: 28px;
      word-wrap: break-word;

      span.gobackBtn {
        width: 10px;
        display: inline-block;
        float: left;
        font-size: @indexFontSize20;
        color: @expertFontColor51;
        padding-right: 10px;

        .van-icon {
          vertical-align: top;
          margin-top: 2px;
        }
      }

      .light_content {
        color: @mainColor;
      }
    }

    // 文章分类，收藏
    .detail_tag_read {
      font-size: @indexFontSize12;
      padding-top: 22px;
      padding-bottom: 16px;
      position: relative;

      .tag {
        display: inline-block;
        padding: 4px;
        border-radius: 4px;
        border: 1px solid #ff67c1;
        font-size: 12px;
        color: #ff67c1;
        line-height: 12px;
        text-align: center;
        margin-right: 4px;
      }

      .read {
        font-size: 12px;
        color: @expertFontColor153;
        line-height: 12px;
      }

      .collect {
        float: right;
        width: 28px;
        height: 35px;
        display: block;
        position: absolute;
        right: 0;
        top: 15px;
        // margin:auto;
      }

      .addColl {
        background: url(../../../assets/images/icon/collect.png) no-repeat
          center center;
        background-size: 20px;
      }

      .cancelColl {
        background: url(../../../assets/images/icon/cancelColl.png) no-repeat
          center center;
        background-size: 28px;
      }
    }
  }

  //内容
  .detail_content {
    border-top: 8px solid @expertBorderColor242;
    padding: 16px 12px 80px;
    height: calc(100% + 1px);
    overflow: hidden;

    /deep/ img {
      max-width: 100% !important;
      height: auto !important;
    }

    /deep/ section {
      max-width: 100% !important;
    }

    /deep/ ul {
      max-width: 100% !important;
    }
  }

  // 关注、分享
  .fixed_btn {
    width: 44px;
    height: 44px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.24);
    position: fixed;
    bottom: 60px;
    right: 12px;
    background: @expertFontColor255;
    border-radius: 22px;
    text-align: center;
    padding-top: 5px;

    span {
      .van-icon {
        font-size: @indexFontSize14;
      }
    }
  }

  //分享遮罩
  .shade {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);

    .share_desc {
      font-size: 18px;
      font-weight: bold;
      color: @expertFontColor255;
      line-height: 28px;
      margin-top: 26px;
      margin-left: 27px;

      p {
        width: 256px;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .share-line {
        text-align: right;
        width: 306px;
        height: 75px;

        img {
          width: 135px;
          height: 75px;
          display: block;
          float: right;
        }
      }

      .btn_close {
        width: 23px;
        height: 23px;
        position: fixed;
        bottom: 106px;
        left: 175px;
      }
    }
  }

  //关注遮罩
  .attent-shade {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);

    .attention {
      color: @expertFontColor255;

      .title {
        margin: 58px auto 0;
        width: 162px;
        font-size: 18px;
        font-weight: bold;
        color: @expertFontColor255;
        line-height: 28px;
      }

      .attent-img {
        text-align: center;
        margin-bottom: 16px;

        img {
          width: 168px;
          height: 228px;
        }
      }

      .attent-class {
        padding-left: 37px;
        display: flex;
        flex-wrap: wrap;

        .attent-item {
          display: flex;
          margin-right: 27px;
          margin-bottom: 30px;

          img {
            width: 22px;
            height: 23px;
            margin-right: 5px;
          }

          p {
            width: 96px;
            font-size: 12px;
            font-weight: bold;
            line-height: 18px;
          }
        }
      }

      .btn {
        width: 23px;
        height: 23px;
        position: fixed;
        left: 174px;
      }
    }
  }
}

@media (max-width: 640px) {
  //商品列表
  .product-list-wrap {
    background: rgba(248, 248, 248, 1);
    overflow: hidden;

    .product-list {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      display: flex;

      .product-item {
        width: 170px;
        height: 245px;
        padding: 14px 10px;
        box-sizing: border-box;
        border-radius: 8px;
        margin-bottom: 14px;
        background: #fff;
        margin-left: 12px;
        // margin-right:5px;
        position: relative;

        img {
          width: 134px;
          height: 134px;
          margin-left: 8px;
          margin-bottom: 8px;
        }

        .product-title {
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          width: 143px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          min-height: 40px;
        }

        .product-desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin-top: 4px;
          width: 150px;
          height: 34px;
          //white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-price {
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(253, 110, 64, 1);
          line-height: 17px;
          margin-top: 8px;
        }

        .tagWrap {
          width: 170px;
          height: 245px;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}

@media (min-width: 640px) {
  .product-list-wrap {
    margin-top: 10px;
    //height: 838px;
    .product-list {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      display: flex;

      .product-item {
        width: 240px;
        height: 245px;
        padding: 14px 40px;
        box-sizing: border-box;
        border-radius: 8px;
        margin-bottom: 14px;
        background: #fff;
        margin-left: 12px;
        //margin-right: 9px;
        img {
          width: 134px;
          height: 134px;
          margin-left: 8px;
          margin-bottom: 8px;
        }

        .product-title {
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          width: 143px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          min-height: 40px;
        }

        .product-desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin-top: 4px;
          width: 150px;
          height: 34px;
          //white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .product-price {
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(253, 110, 64, 1);
          line-height: 17px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue"; //轮播图
import {
  Debounce,
  fomatterNum,
  gainReady,
  getCookie,
  getHeadImgAndName,
  getUrlParamsByName,
  goToMini,
  setCookie,
  TestUserAgent,
  isFromMiniprogram,
} from "@/assets/js/common.js";
import shareGuide from "@/components/common/shareGuide.vue";
import commentField from "@/components/comment/commentField.vue";
import allComment from "@/components/comment/allComment.vue";
import {
  Exposurer_babyDetail,
  Exposurer_home,
} from "../../../assets/js/Exposure";
import goBack from "@/components/common/goBack.vue";
import openWxTag from "@/components/common/openWeappTag/index.vue"; // 打开小程序开放标签
import loginTip from "@/components/common/loginPop/index.vue"; //注册提示组件
import { setTimeout } from "timers";
import {
  BuiedPointClick_Fn,
  Exposurer_babyList_Fn,
  xmhH5_xyewz_goods_view,
  xmhH5_article_goods_view,
} from "@/assets/js/BuriedPointEvent";
import wx from "weixin-js-sdk";
import { addIntegral, inquireTime } from "@/utils/newMemberApiGlobal";

import API from "@/utils/axiosApi/getUserInfoIntellect"; //智能推算接口
import { getFindStart } from "@/assets/js/commonGetInfo.js";
import { commonOperationEvent } from "@/utils/commonApiList";

export default {
  name: "BabyDetail",
  components: {
    shareGuide,
    commentField,
    allComment,
    goBack,
    mySwiper,
    openWxTag,
    loginTip,
  },
  data() {
    return {
      issystem: TestUserAgent().isios,
      content: "",
      commodityObj: {},
      recommendList: [], //星妈优选
      flag: false, //分享弹窗
      articalId: this.$route.params.id, //id文章
      title: "",
      pv: 12.2,
      articalDetial: "",
      datailpage: true,
      collectShow: false, //收藏
      curCollType: true,
      imgUrl: "", //分享图片地址
      userInfo: null, //用户信息
      handleParams: {
        type: "babyAdd",
        number: this.$route.params.id,
      },
      articleTList: null,
      tlabelName: "",
      timer: null,
      babyDetailShow: false,
      currentTop: "",
      carrierId: "2",
      isGoLogin: false,
      collectNum: "",
      commentTotal: "",
      scrollWatch: true,
      scrollTop: "",
      commentFlag: true,
      articleItemSetId: "",
      articleSceneId: "",
      shopItemSetId: "",
      shopSceneId: "",
      requestId: "",
      isListLoading: false,
      itemList: [],
      finished: false,
      page: 1,
      finishText: "",
      startMomList: [],
      startMomFlag: false,
      lookTimer: null,
      readingTime: 1,
      isRecommendSwitch: 0,
      fromSource: "星妈会", // 前向来源
      appId:
        this.$http.hostName === "https://mom.feihe.com"
          ? "gh_fe3214457b8e"
          : "gh_0b629d0f8f67", // 小程序appid
      // loginPopflag: false
      fromPath: "",
      isScrollSown: false, //判断滚动条到底部时只执行一次
      referrerItemId: 0, //来源文章（当前文章）物料id
      previousTitle: "",
      readingArticleDuration: 10,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
      console.log(from, "from.query");
      vm.previousTitle =
        from.query.previousTitle || from.meta.title || document.title;
      vm.fromSource = vm.$route.query.source == "chunyu" ? "春雨" : "星妈会";
      vm.$store.commit("changeIncludes", [
        "home",
        "BabyList",
        "BabyIndex",
        "collection",
        "wikipediaIndex",
        "wikipediaList",
        "powderedMilkList",
        "powderedMilk",
        "milkArticleLists",
        "aiBenHome",
        "feedRecord",
        "scientificFeed"
      ]); //BabyDetail
      // 如果不是在注册页返回的，走原有的流程，否则停留在当前页面
      if (!getUrlParamsByName("fromLogin")) {
        vm.wxJsSet.wxLoginFn(vm, vm.handleParams, function () {
          if (
            !vm.collectShow &&
            vm.$route.query.babyAdd == localStorage.getItem("babyAdd")
          ) {
            vm.collectAjax();
          } else {
            localStorage.removeItem("babyAdd");
          }
        });
      }
      if (
        localStorage.getItem("userInfo") != null &&
        localStorage.getItem("userInfo") != "" &&
        JSON.parse(localStorage.getItem("userInfo")).mobile != null &&
        JSON.parse(localStorage.getItem("userInfo")).mobile != ""
      ) {
        vm.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      } else {
        vm.isGoLogin = true;
      }
      vm.getUserName();
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "collection") {
      this.$store.commit("changeIncludes", ["collection"]);
    }
    this.scrollWatch = false;
    // window.removeEventListener('scroll', this.handleScroll);
    next();
  },
  computed: {
    // 判断是否来自小程序
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route);
    }
  },
  async mounted() {
    if (this.userInfo && this.userInfo.crm_id) {
      await getFindStart(this.userInfo.crm_id);
    }
    document.addEventListener("scroll", Debounce(this.handleScroll), true);
    this.isRecommendSwitch = sessionStorage.getItem("isRecommendSwitch");
    var date = Date.parse(new Date());
    var id = this.getCookie("xmh_unionid");
    this.requestId = this.$md5(date + id);
    if (this.$http.hostName == "https://mom.feihe.com") {
      // 正式环境物料id和服务id
      if (this.$route.query.source == "home") {
        this.articleItemSetId = "16";
        this.articleSceneId = "32";
      } else if (this.$route.query.source == "baby") {
        this.articleItemSetId = "16";
        this.articleSceneId = "312";
      } else {
        this.articleItemSetId = "16";
        this.articleSceneId = "41";
      }
      this.shopItemSetId = "151";
      this.shopSceneId = "329";
    } else {
      // uat环境物料id和服务id
      // this.itemSetId='72368'
      // this.sceneId='79389'
      if (this.$route.query.source == "home") {
        this.articleItemSetId = "12";
        this.articleSceneId = "21";
      } else if (this.$route.query.source == "baby") {
        this.articleItemSetId = "12";
        this.articleSceneId = "303";
      } else {
        this.articleItemSetId = "12";
        this.articleSceneId = "296";
      }
      this.shopItemSetId = "153";
      this.shopSceneId = "326";
    }
    if (this.isRecommendSwitch == 0) {
      this.getcontentList();
      this.getroadList();
    }
    this.durationTime();
    setTimeout(() => {
      Exposurer_home.observe(".product-item", false, {
        List: this.startMomList,
        that: this,
        type: "baby",
      });
    }, 3000);
    setTimeout(() => {
      var nwbkLoginPop = this.getCookie("nwbkLoginPop");
      if (
        !nwbkLoginPop &&
        (!this.userInfo ||
          this.userInfo.crm_id == "" ||
          this.userInfo.mobile == "")
      ) {
        // this.loginPopflag = true
        this.setCookie("nwbkLoginPop", true, 1);
      }
    }, 10000);
  },
  watch: {
    readingTime: {
      handler(newValue) {
        // console.log(newValue, this.readingArticleDuration, '==readingArticleDuration')
        if (newValue === this.readingArticleDuration) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          addIntegral(
            {
              taskGroupCode: "YDWZ00002",
              crmId: userInfo?.crm_id,
            },
            this,
            "星育儿文章浏览完成"
          );
        }
      },
    },
    "$route.params": {
      handler(newValue) {
        if (newValue && newValue.id) {
          this.articalId = newValue.id;
          this.handleParams.number = newValue.id;
          this.getDetail();
        }
        console.log(newValue, "newValuenewValue");
      },
      deep: true,
      immediate: true,
    },
  },
  deactivated() {
    this.$store.commit("deleteDYIncludes", "BabyIndex");
  },
  created() {
    const oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.src = "https://res2.wx.qq.com/open/js/jweixin-1.6.0.js";
    document.body.appendChild(oScript);
    if (this.articalId) {
      // this.getDetail();
    } else {
      this.datailpage = false;
    }
    inquireTime((value) => {
      this.readingArticleDuration = value.readingArticleDuration;
      console.log(value, "readingArticleDuration");
    }, this);
    if (
      localStorage.getItem("userInfo") != null &&
      localStorage.getItem("userInfo") != "" &&
      JSON.parse(localStorage.getItem("userInfo")).mobile != null &&
      JSON.parse(localStorage.getItem("userInfo")).mobile != ""
    ) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      // this.getCollectCheck();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    this.scrollWatch = false;
    document.removeEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    this.scrollWatch = false;
  },
  updated() {},
  methods: {
    collectNumAdd(e) {
      this.collectNum = this.collectNum + e;
    },
    getCookie,
    setCookie,
    fomatterNum,
    gainReady,
    goToMini,
    getUserName: async function () {
      try {
        const { headImgurl, nickName } = await getHeadImgAndName();
        this.setCookie("xmh_headimgurl", headImgurl, 365);
        this.setCookie("xmh_nickname", nickName, 365);
      } catch (err) {}
    },
    toArticle(item, index) {
      sensors.track("ProductClick", {
        commodity_class1: item.rootCategoryName,
        commodity_class2: item.leafCategoryName,
        commodity_id: item.itemId,
        commodity_name: item.itemTitle,
        cash_number: item.payType == 8 ? item.price : 0,
        point_number: item.payType == 6 ? item.price : 0,
        operate_name: "奶娃百科文章底部推荐",
        operate_content: "商品推荐",
        itemSetId: this.shopItemSetId,
        sceneId: this.shopSceneId,
        context: item.sequenceId,
        requestId: this.requestId,
        $title: this.$route.meta.title,
        position: index + 1,
      });
      var that = this;
      this.durationTimeReport();
      clearTimeout(this.lookTimer);
      // setTimeout(function () {
      //   location.href =
      //     item.jumpUrl +
      //     "&xmhSource=nwbkShop&sceneId=" +
      //     that.shopSceneId +
      //     "&itemSetId=" +
      //     that.shopItemSetId;
      // }, 200);
    },
    //推荐列表
    getcontentList() {
      var that = this;
      var id = this.getCookie("xmh_unionid");
      API.getRecommendList(
        {
          userId: id,
        },
        (res) => {
          if (res.code == 200) {
            this.recommendList = res.data;
            this.recommendList.forEach((item, index) => {
              item.index = index;
            });
            // 神策曝光埋点
            setTimeout(() => {
              Exposurer_babyList_Fn.observe(
                "NewsShown",
                ".recommend-cont-list",
                false
              );
              Exposurer_babyDetail.observe(".recommend-cont-list", false, {
                requestId: that.requestId,
                source: "babydetail",
              });
            }, 300);
          }
        }
      );
    },
    //推荐列表
    getroadList(code) {
      var id = this.getCookie("xmh_unionid");
      this.$http.post(
        "/recommend/product/getList",
        {},
        {
          crmId: this.userInfo?.crm_id || "",
          openId: getCookie("xmh_openid"),
          pageNo: this.page,
          pageSize: 10,
        },
        (res) => {
          const { code, data } = res;
          if (code === 200) {
            if (data.length != 0) {
              $(".commentWrap").css("paddingBottom", "0px");
            }
            if (this.page >= "2") {
              this.startMomFlag = true;
            }
            this.startMomList = [];
            this.itemList.push(...data);
            this.startMomList.push(...data);
            this.finished = true; // 停止加载
            this.finishText = "—我是有底线的—";
            setTimeout(() => {
              this.currentTop = $(".commentWrap").offset()
                ? $(".commentWrap").offset().top
                : 0;
              console.log("this.currentTop", this.currentTop);
            }, 500);
          }
        },
        () => {},
        "lucky"
      );
    },
    // 判断 当前页面的环境
    setgain(callback) {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            callback && callback(1);
          } else {
            callback && callback(2);
          }
        });
      }
    },
    //获取详情
    getDetail() {
      this.$http.get(
        "/babyWiki/article/detail",
        { id: this.articalId, source: this.$route.query.source },
        (res) => {
          if (res.code === 200) {
            let map = this.getParameterMap();
            console.log(res, "res.data.content");
            if (res.data === null) {
              this.$toast({
                duration: 2000,
                message: res.message,
              });
              // this.$router.go(-1)
              // return
            }
            this.content = res.data.content;
            this.commodityObj = res.data;
            if (map) {
              this.commodityObj.traceId = map.get("itemTraceId");
              this.commodityObj.itemType = map.get("itemType");
            }
            this.referrerItemId = res.data.id;
            console.log(this.referrerItemId, "this.referrerItemId");
            console.log(this.commodityObj, "文章详情");
            setTimeout(() => {
              this.reportUserBehavior(this.commodityObj, "曝光");
            }, 200);
            // console.log(this.commodityObj,'this.commodityObj');
            // let DOMclientHeight = document.documentElement.clientHeight
            // let DOMscrollHeight = document.documentElement.scrollHeight
            //如果页面不具有滚动条，则进入文章详情页后就进行埋点
            // if(DOMclientHeight == DOMscrollHeight){
            //   BuiedPointClick_Fn('xmhh5_article_detail_viewdone',{
            //         xmhh5_article_title:res.data.title
            //   })
            // }
            this.setgain((value) => {
              BuiedPointClick_Fn("xmhh5_article_detail_view", {
                xmhh5_article_title: res.data.title,
                xmhh5_articleview_previouspage: this.previousTitle,
                xmhh5_Article_Source:
                  value === 1 ? "星鲜优选小程序" : "星妈会h5",
              });
            });

            this.$nextTick(() => {
              // 增加星育儿文章埋点 手动曝光埋点
              xmhH5_xyewz_goods_view.observe(
                "xmhH5_xyewz_goods_view",
                ".feiheEditorItemGoods",
                false,
                {
                  xmhh5_article_title: res.data.title,
                }
              );
            });
            const { plist, contentTagList, monthTagList, monthAge } = res.data;
            this.articleTList = res.data.monthTagList;
            this.articalDetial = res.data.content;
            this.babyDetailShow = true;

            const classifySensor = (data = []) => {
              return (
                data &&
                data.reduce((prev, next) => {
                  return (prev += next.name + ",");
                }, "")
              );
            };
            if (
              this.articalId == "13050" &&
              this.$http.hostName == "https://mom.feihe.com"
            ) {
              this.articalDetial = this.articalDetial.replace(
                /opacity: 0/g,
                "opacity:1; height:100% !important"
              );
            } else if (
              this.articalId == "11472" &&
              this.$http.hostName == "https://momuat.feihe.com"
            ) {
              this.articalDetial = this.articalDetial.replace(
                /opacity: 0/g,
                "opacity:1; height:100% !important"
              );
            }
            // 月龄标签埋点

            this.articalDetial = this.articalDetial.replace(/data-src/g, "src");
            this.title = res.data.title;
            var that = this;
            var context = that.getCookie("context");
            $(document).ready(function () {
              $("a").click(function () {
                sensors.track("ToLearnClick", {
                  content_id: that.articalId,
                  content_title: that.title,
                  author: "",
                  itemSetId: that.articleItemSetId,
                  sceneId: that.articleSceneId,
                  context: that.$route.query.source == "home" ? context : "",
                  requestId: that.requestId,
                  page_name: that.$route.meta.title,
                });
              });
            });
            this.pv = fomatterNum(res.data.clickNum);
            this.collectNum = res.data.collectNum;
            if (this.articleTList != null && this.articleTList.length != 0) {
              this.tlabelName = this.articleTList[0].name;
            }

            setTimeout(() => {
              sensors.track("ContentView", {
                content_type: this.tlabelName,
                content_title: that.title,
                content_id: this.articalId,
                author: "",
                Primary_classification:
                  contentTagList && classifySensor(contentTagList), //一级分类
                Secondary_classification:
                  monthTagList && classifySensor(monthTagList), //二级分类
                Month_age: plist && classifySensor(plist), //月龄标签
                Day_age: monthAge || "", // 月龄日期
                itemSetId: this.articleItemSetId,
                sceneId: this.articleSceneId,
                requestId: this.requestId,
                context: this.getCookie("context")
                  ? this.getCookie("context")
                  : "",
                Channel_cy: this.fromSource,
              });
            }, 2000);
            var that = this;
            var detailContent = res.data;
            var shareTask = true;
            var shareTaskId = "nwbkfx_" + this.articalId;
            var shareDataParams = {
              shareLink: location.href.split("#")[0],
              shareDesc:
                detailContent.contentDesc.length > 28
                  ? detailContent.contentDesc.slice(0, 28) + "..."
                  : detailContent.contentDesc,
              shareTitle:
                detailContent.title.length > 28
                  ? detailContent.title.slice(0, 28) + "..."
                  : detailContent.title,
              imgUrl:
                detailContent.coverUrl ||
                "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
              shareGioFn: function () {
                gio("track", "articleShareSuccessClick", {
                  articleTitle_var: that.title,
                  articleLabel_var: that.tlabelName,
                });
              },
              isBabyShare: true,
              babyShareSuccess: function (type) {
                that.$toast({
                  duration: 2000,
                  message: "分享成功",
                  context: this,
                });
                // 神策埋点
                sensors.track("ContentShare_Click", {
                  content_id: that.articalId,
                  content_title: that.title,
                  Share_Type: type == 1 ? "分享到朋友圈" : "发送给朋友",
                  itemSetId: that.articleItemSetId,
                  sceneId: that.articleSceneId,
                  context: that.getCookie("context")
                    ? that.getCookie("context")
                    : "",
                  requestId: that.requestId,
                });
              },
              contentId: this.articalId,
              babyShow: true,
              sourceHome: this.$route.query.source == "home" ? true : false,
            };
            this.wxJsSet.wxShare("fx", shareDataParams, this, () => {
              if (this.commodityObj.itemTraceId || this.commodityObj.traceId) {
                //文章智能推荐
                var id = this.getCookie("xmh_unionid");
                const pkData = {
                  itemId: `${this.commodityObj.id}`,
                  itemTraceId: this.commodityObj.itemTraceId
                    ? this.commodityObj.itemTraceId
                    : this.commodityObj.traceId,
                  itemType: this.commodityObj.itemType,
                };
                const vote = {
                  crmId: id,
                  behaviorType: 5,
                  itemData: [pkData],
                  referrerItemId: `${this.referrerItemId}`,
                  commentText: "", //非必填
                  duration: this.readingTime,
                };
                console.warn(vote, "1301");
                setTimeout(() => {
                  API.reportUserBehavior({}, vote, (res) => {
                    if (res.code == 200) {
                      console.log(res, "用户智能推算成功");
                    } else {
                      console.error("请求失败");
                    }
                  });
                }, 200);
              }
            });
            // 文章加载3秒后提示任务完成
            // if(this.userInfo.mobile != null && this.userInfo.mobile!=""){
            // this.timer = setTimeout(() => {
            //   this.taskFinish();
            // }, 3000);

            if (this.isRecommendSwitch != 0) {
              setTimeout(() => {
                this.currentTop = $(".commentWrap").offset().top;
                console.log("this.currentTop", this.currentTop);
              }, 500);
            }
            this.$nextTick(() => {
              this.handleScroll();
              xmhH5_article_goods_view.observe(
                "Parenting_Article_Goods_View",
                ".wx-open-launch-weapp"
              );
              const btn = document.getElementsByClassName(
                "wx-open-launch-weapp"
              );
              for (let i = 0; i < btn.length; i++) {
                btn[i].addEventListener("launch", function (e) {
                  let data = btn[i].attributes.data
                    ? JSON.parse(btn[i].attributes.data.nodeValue)
                    : {};
                  console.log(data, "&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
                  BuiedPointClick_Fn("Parenting_Article_Goods_Click", {
                    Parenting_Goods_Click_Name: data.commodityName,
                  });
                });
                btn[i].addEventListener("click", function (e) {
                  let data = btn[i].attributes.data
                    ? JSON.parse(btn[i].attributes.data.nodeValue)
                    : {};
                  wx.miniProgram.getEnv((res) => {
                    if (res.miniprogram) {
                      BuiedPointClick_Fn("Parenting_Article_Goods_Click", {
                        Parenting_Goods_Click_Name: data.commodityName,
                      });
                      wx.miniProgram.navigateTo({
                        url: data.path,
                      });
                    }
                  });
                });
              }
            });
          } else {
            this.datailpage = false;
          }
        },
        (err) => {},
        "lucky"
      );
    },

    //收藏与取消收藏
    collect: function (type) {
      this.curCollType = type;
      var that = this;
      console.log(type, "this.curCollType");
      localStorage.setItem("babyAdd", this.articalId);
      this.wxJsSet.wxHandleBeforeFn(that, that.handleParams, that.collectAjax);
    },
    collectAjax() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (this.curCollType) {
        //收藏
        commonOperationEvent({
          crmId: this.userInfo.crm_id,
          itemId: this.articalId,
          type: 0,
          actionType: 1,
        }).then((res) => {
          if (res.code == 200) {
            // this.$toast({
            //     duration:2000,
            //     message:'收藏成功'
            // })
            this.collectShow = true;
            this.localStorage.removeItem("babyAdd");
            this.$toast({
              duration: 2000,
              message: "收藏成功",
              context: this,
            });
          }
        });
      } else {
        //取消收藏
        commonOperationEvent({
          crmId: this.userInfo.crm_id,
          itemId: this.articalId,
          type: 1,
          actionType: 1,
        }).then((res) => {
          if (res.code == 200) {
            this.collectShow = false;
            localStorage.removeItem("babyAdd");
          }
        });
      }
    },
    //判断用户是否收藏
    getCollectCheck() {
      this.$http.get(
        "/babyWiki/article/collectCheck",
        { crmId: this.userInfo.crm_id, id: this.articalId },
        (res) => {
          if (res.data == true) {
            this.collectShow = true;
          } else {
            this.collectShow = false;
          }
        },
        (err) => {},
        "lucky"
      );
    },
    getCommentTotal(data) {
      this.commentTotal = data;
    },
    // 跳转百科详情
    toBabyDetail: function (item, index) {
      //TODO:文章智能推荐
      var id = this.getCookie("xmh_unionid");
      const pkData = {
        itemId: `${item.id}`,
        itemTraceId: item.itemTraceId,
        itemType: item.itemType,
      };
      const vote = {
        crmId: id,
        behaviorType: 2,
        itemData: [pkData],
        referrerItemId: `${this.referrerItemId}`,
        // commentText//非必填
        duration: this.readingTime,
      };
      console.warn(vote);
      setTimeout(() => {
        API.reportUserBehavior({}, vote, (res) => {
          if (res.code == 200) {
            console.log(res, "用户智能推算成功");
          } else {
            console.error("请求失败");
          }
        });
      }, 200);

      // console.warn(item, 'item智能')
      var itemSetId = "";
      var sceneId = "";
      if (this.$http.hostName == "https://mom.feihe.com") {
        itemSetId = "16";
        sceneId = "312";
      } else {
        itemSetId = "12";
        sceneId = "303";
      }
      var date = Date.parse(new Date());

      var requestId = this.$md5(date + id);
      BuiedPointClick_Fn("NewsClick", {
        xmhh5_articletitle_view_pagename: this.$route.meta.title,
        xmhh5_article_title: item.title,
      });

      this.durationTimeReport();
      clearTimeout(this.lookTimer);
      this.articalId = item.id;
      this.setCookie("context", item.context);
      setTimeout(() => {
        location.href =
          "/baby/detail/" +
          item.id +
          "?source=baby" +
          `&itemTraceId=${item.itemTraceId}&itemType=${item.itemType}`;
      }, 200);

      //   this.getDetail();
      //   window.scrollTo(0,0);
    },
    tobabyHander() {
      this.gainReady(null, () => {
        this.durationTimeReport();
        this.articlePioal();
        setTimeout(() => {
          if (this.fromSource === "春雨") {
            window.history.go(-1);
          } else {
            if (sessionStorage.getItem("toLogin")) {
              this.$router.push("/home");
            } else if (
              this.$route.query.source == "home" ||
              this.getCookie("fromPath") == "/home"
            ) {
              if (window.history.length > 1) {
                this.$router.go(-1);
              } else {
                this.$router.replace("/home");
              }
            } else if (
              this.$route.query.source == "powderedMilk" ||
              this.getCookie("fromPath") == "/powderedMilk"
            ) {
              if (window.history.length > 1) {
                this.$router.go(-1);
              } else {
                this.$router.replace("/powderedMilk");
              }
            } else if (
              this.$route.query.source == "milkArticleLists" ||
              this.getCookie("fromPath") == "/milkArticleLists"
            ) {
              // alert(this.$router.go(-1))
              if (window.history.length > 1) {
                this.$router.go(-1);
              } else {
                this.$router.replace("/powderedMilk");
              }
              // window.history.length > 1 && this.$router.go(-1)
            } else if (!this.$route.query.source && this.fromPath == "/") {
              this.$router.push("/babyWikipedia");
            } else if (
              !this.$route.query.source == "feedRecord" ||
              this.getCookie("fromPath") == "/feedRecord"
            ) {
              if (window.history.length > 1) {
                this.$router.go(-1);
              } else {
                this.$router.replace("/feedRecord");
              }
            } else if (
              this.$route.query.source == "scientificFeed" ||
              this.getCookie("fromPath") == "/scientificFeed"
            ) {
              if (window.history.length > 1) {
                this.$router.go(-1);
              } else {
                this.$router.replace("/feedRecord");
              }
            } else if(!this.$route.query.source && this.fromPath == "/") {
              this.$router.push("/babyWikipedia");
            }else if (
              window.history.length > 1 &&
              this.getCookie("fromPath")
            ) {
              this.$router.go(-1);
            } else {
              this.$router.push("/babyWikipedia");
            }
          }
        }, 200);
      });
    },
    articlePioal() {
      // alert(this.previousTitle)
      BuiedPointClick_Fn("xmhh5_article_detail_quitread", {
        xmhh5_article_title: this.title,
        xmhh5_articleview_previouspage: this.previousTitle,
      });
    },
    // Gio点击分享按钮埋点
    gioShare: function () {},
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool;
    },
    getType(type) {
      this.$refs.focus.type = type;
    },
    // 统计阅读时长
    durationTime() {
      var that = this;
      this.lookTimer = setInterval(function () {
        that.readingTime++;
      }, 1000);
    },
    // 神策阅读时长上报
    durationTimeReport() {
      sensors.track("reading", {
        content_id: this.articalId,
        Reading_position: "首页热门推荐文章详情",
        Reading_time: this.readingTime,
        itemSetId: this.articleItemSetId,
        sceneId: this.articleSceneId,
        requestId: this.requestId,
        context: this.getCookie("context") ? this.getCookie("context") : "",
      });
      let map = this.getParameterMap();

      //智能文章推荐
      if (map) {
        this.commodityObj.traceId = map.get("itemTraceId");
        this.commodityObj.itemType = map.get("itemType");
      }

      if (this.commodityObj.itemTraceId || this.commodityObj.traceId) {
        //文章智能推荐
        var id = this.getCookie("xmh_unionid");
        const pkData = {
          itemId: `${this.commodityObj.id}`,
          itemTraceId: this.commodityObj.itemTraceId
            ? this.commodityObj.itemTraceId
            : this.commodityObj.traceId,
          itemType: this.commodityObj.itemType,
        };
        const vote = {
          crmId: id,
          behaviorType: 3,
          itemData: [pkData],
          referrerItemId: `${this.referrerItemId}`,
          commentText: "", //非必填
          duration: this.readingTime,
        };
        console.warn(vote, "1911");
        setTimeout(() => {
          API.reportUserBehavior({}, vote, (res) => {
            if (res.code == 200) {
              console.log(res, "用户智能推算成功");
            } else {
              console.error("请求失败");
            }
          });
        }, 200);
      }
    },

    //滚动条监听
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      //当isScrollSown为false时，判断时第一次进入，滚动到底部时进行埋点，改变值为true。后面不在进行埋点
      if (!this.isScrollSown) {
        //总高度减去盒子高度减去全部留言高度减去上面两个空盒子高度
        if (Math.ceil(scrollTop) >= scrollHeight - clientHeight - 294 + 90) {
          //滑动到到全部留言进行埋点
          BuiedPointClick_Fn("xmhh5_article_detail_viewdone", {
            xmhh5_article_title: this.title,
            xmhh5_articleview_previouspage: this.previousTitle,
          });
          this.isScrollSown = true;
        }
      }
    },
    // confirmWay(){
    //   this.loginPopflag = false
    //   sensors.track('RegisterWindowClick', {
    //     button_name: '去注册',
    //     page_name: this.$route.meta.title,
    //     content_name: '奶娃百科'
    //   })
    //   setTimeout( () => {
    //     this.$router.push({ path: '/phoneLogin?redirect=' + window.location.href });
    //   }, 200)
    // },
    // cancleWay(){
    //   this.loginPopflag = false
    //   sensors.track('RegisterWindowClick', {
    //     button_name: '狠心放弃',
    //     page_name: this.$route.meta.title,
    //     content_name: '奶娃百科'
    //   })
    // }
    //智能文章推荐
    reportUserBehavior(item, action, commentText) {
      if (item.itemTraceId || item.traceId) {
        //文章智能推荐
        var id = this.getCookie("xmh_unionid");
        const pkData = {
          itemId: `${item.id}`,
          itemTraceId: item.itemTraceId ? item.itemTraceId : item.traceId,
          itemType: item.itemType,
        };
        const vote = {
          crmId: id,
          behaviorType:
            action === "曝光"
              ? 1
              : action === "点击"
              ? 2
              : action === "停留"
              ? 3
              : action === "收藏"
              ? 4
              : action === "分享"
              ? 5
              : action === "评论"
              ? 6
              : 0,
          itemData: [pkData],
          referrerItemId: `${this.referrerItemId}`,
          commentText: commentText ? commentText : "", //非必填
          duration: this.readingTime,
        };
        if (action === "曝光") {
          console.warn(vote, "1191");
        }
        setTimeout(() => {
          API.reportUserBehavior({}, vote, (res) => {
            if (res.code == 200) {
              console.log(res, "用户智能推算成功");
            } else {
              console.error("请求失败");
            }
          });
        }, 200);
      }
    },
    //取出location的值
    getParameterMap() {
      let parameters = window.location.search;
      // 如果没有参数
      if (parameters.indexOf("?") == -1) return null;
      let map = new Map();
      let strs = parameters.substr(1).split("&");
      for (let i = 0; i < strs.length; i++) {
        let str = strs[i].split("=");
        map.set(str[0], str[1]);
      }
      return map;
    },
  },
};
</script>
